import { cn } from '@repo/lib/cn';

/**
 * Props for SettingOptionHeader component.
 * @property {string} title - The header title.
 * @property {string} description - The header description.
 * @property {string} [className] - Optional additional class names.
 */
interface SettingOptionHeaderProps {
  title: string;
  description: string;
  className?: string;
}

export default function SettingOptionHeader(settingOptionHeaderProps: SettingOptionHeaderProps) {
  const { title, description, className } = settingOptionHeaderProps;
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <h5 className={'text-md text-text-primary w-full overflow-hidden font-medium text-ellipsis whitespace-nowrap'}>{title}</h5>
      <p className={'text-text-tertiary overflow-hidden text-sm text-ellipsis whitespace-normal'}>{description}</p>
    </div>
  );
}
